// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__vqItQ","description":"card_description__A0RU_"};